import * as React from 'react';
import { FC, Fragment, useEffect } from 'react';
import {
    BooleanField,
    Filter,
    List,
    TextField,
    usePermissions,
    useTranslate,
    SearchInput,
    ReferenceField
} from 'react-admin';

import ListActions from '../components/actions';
import BulkDeleteButton from '../components/actionsBulkDelete';
import exporter from './exporter';
import ListEmpty from '../components/listEmpty';
import { FilterProps, PermissionsType } from "../../types";
import ListPagination from "../components/ListPagination";
import CustomizableDatagrid from '../components/CustomizableDatagrid';
import Fields from './dataset';
import { NumberField } from 'react-admin';
import { SelectField } from 'react-admin';
import ChipFieldJsonb from '../components/ChipFieldJsonb';
import { TextInput } from 'react-admin';
import { NumberInput } from 'react-admin';
import ReferenceEventContact from './ReferenceField'
import { DateField } from 'react-admin';
import { useHistory } from 'react-router';
import { useApolloClient } from '@apollo/client';
import ReferenceFieldAge from './ReferenceFieldAge';

const ExportableFields = Fields.filter(d => d.export);

const UserBulkActionButtons = (props: JSX.IntrinsicAttributes) => {
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    return (
        <Fragment>
            {(role === 'admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkDeleteButton {...props} />}
        </Fragment>
    )
};
const TeamFilter: FC<Omit<FilterProps, 'children'>> = props => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <NumberInput source="id@_eq" label={translate('user_list.id')} alwaysOn />
            <SearchInput source="lastname,firstname,firstname_kana,lastname_kana,note" alwaysOn />
        </Filter>
    )
};

const AccountReferenceField = (props: any) => {
    return <ReferenceField link={false} source={'account_id'} reference={'account'}  {...props}>
        <TextField source={'name'} />
    </ReferenceField>
}
const StaffList = (props: any) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const apolloClient = useApolloClient();
    const permission = permissions?.list_permission as PermissionsType;
    let edit = (permission?.permission_create_edit == true || permission?.permission_all == true) ? 'edit' : '';
    const module = 'event_application';
    const history = useHistory();
    useEffect(() => {
        history.location.pathname = '/event_application';
    }, [props]);
    if (role === undefined) {
        return null;
    }
    console.log({ permissions });

    return (
        <List
            {...props}
            filters={<TeamFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
            bulkActionButtons={<UserBulkActionButtons />}
            pagination={<ListPagination />}
            exporter={(items: any, fetchRelatedRecords: any) => exporter(items, 'event_application', ExportableFields, translate, fetchRelatedRecords, apolloClient)}
            actions={<ListActions to='event_application' />}
            empty={<ListEmpty />}
            title={translate(' ')}
        >
            <CustomizableDatagrid rowClick={edit}>

                {Fields.map((f, idx) => {
                    if (!Boolean(f)) return <></>
                    const { name, reference, searchField, type, options } = f || {}
                    if (type === 'textinput' && name !== 'created') {

                        return <TextField source={name} label={translate(`${module}.${name}`)} />
                    }
                    if (type === 'reference' && name === 'event_contact_id') {
                        return <ReferenceField label={translate(`${module}.${name}`)} source={name} reference={reference}>
                            <ReferenceEventContact label={translate(`${module}.${name}`)} source={'user_id'} reference={'user'} />
                        </ReferenceField>
                        //return <ReferenceEventContact label={translate(`${module}.${name}`)} source={name} reference={reference}/>

                    }
                    if (type === 'reference') {
                        return <ReferenceField label={translate(`${module}.${name}`)} source={name} reference={reference}>
                            <TextField source={searchField} />
                        </ReferenceField>
                    }

                    if (type === 'checkbox') {
                        return <BooleanField source={name} label={translate(`${module}.${name}`)} />
                    }

                    if (type === 'selectbox') {
                        return <SelectField
                            source={name}
                            choices={options}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'age') {
                        return <ReferenceFieldAge
                            source={name}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'jsonb') {
                        return <ChipFieldJsonb
                            source={name}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'status') {
                        return <SelectField
                            source={name}
                            choices={options}
                            label={translate(`${module}.${name}`)}
                        />
                    }
                    if (type === 'date') {
                        if (name === 'birthday') {
                            return <DateField source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />

                        }
                        return <DateField showTime={true} source={name} label={translate(`${module}.${name}`)} locales="ja-JP" />
                    }
                    if (name == 'account_name') {
                        return <ReferenceField link={false} label={translate(`${module}.account_name`)} source={'event_contact_id'} reference={'event_contact'}>
                            <ReferenceField link={false} source={'event_id'} reference={'event'}>
                                <AccountReferenceField />
                            </ReferenceField>
                        </ReferenceField>
                    }
                    return <></>
                })}
            </CustomizableDatagrid>
        </List>

    );
};

export default StaffList;
